import * as React from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Grid, TextField } from "@material-ui/core";
import { SnackbarNotifier } from "../panel/MUI";
import { tl } from "../../utils";
import * as styles from "./styles.scss";
import { IAPIData, IAPIMessage } from "./types";
import { LoginPageContext } from "./context";

export const RestoreForm = ({ apiData }: { apiData: IAPIData }) => {
  const history = useHistory();
  const { addNotice } = React.useContext(LoginPageContext);

  const [email, setEmail] = React.useState<string>("");
  const [message, setMessage] = React.useState<IAPIMessage | null>(null);

  const onRestore = async (evt: React.FormEvent) => {
    evt.preventDefault();
    evt.stopPropagation();

    const data = new FormData();
    data.append("email", email);

    const response = await fetch(`${apiData.url}`, {
      method: "post",
      credentials: "include",
      body: data,
    });

    const result = await response.json();

    if (result.status === "ok") {
      addNotice(result.content, "success");
      history.push("/login");
    } else {
      setMessage({
        message: result.message,
        messageType: "error",
      });
    }
  };

  return (
    <div className={`${styles.wrap} ${styles.wrapRestore}`}>
      <form action="#" onSubmit={onRestore}>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Box className={styles.title} textAlign="center">
              {tl("Восстановление доступа")}
            </Box>
          </Grid>
          {message ? (
            <Grid item>
              <SnackbarNotifier inline note={message} />
            </Grid>
          ) : null}
          <Box clone textAlign="center">
            <Grid item>
              {tl("Введите E-mail для получения пароля от сервиса")}
            </Grid>
          </Box>
          <Grid item>
            <TextField
              variant="outlined"
              color="primary"
              type="email"
              fullWidth
              placeholder={tl("E-mail адрес")}
              onChange={(evt) => {
                setEmail(evt.target.value);
              }}
            />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                {tl("Восстановить пароль")}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button variant="contained" fullWidth onClick={history.goBack}>
                {tl("Вернуться назад")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
